import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '../../data/navigation';
import { assetUrl } from '../../lib/assetUrl';
import './NavBar.css';

const NAV_ID = 'site-nav';

const linkClassName = ({ isActive }) =>
  isActive ? 'site-nav__link is-active' : 'site-nav__link';

export default function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <NavLink to="/" className="site-header__brand">
          <img
            src={assetUrl('images/logo-nobg.png')}
            alt="Paw Global Veterinary"
            width="1728"
            height="910"
          />
        </NavLink>

        <button
          type="button"
          className="site-header__toggle"
          aria-expanded={isOpen}
          aria-controls={NAV_ID}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setIsOpen((open) => !open)}
        >
          <span className="site-header__toggle-icon" aria-hidden="true" />
        </button>

        <nav id={NAV_ID} className={isOpen ? 'site-nav is-open' : 'site-nav'} aria-label="Primary">
          <ul className="site-nav__list">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <NavLink to={to} end={to === '/'} className={linkClassName} onClick={closeMenu}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
